import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import vuexI18n from 'vuex-i18n'
import Vuex from 'vuex'
import ToastPlugin from 'vux/src/plugins/toast'
// import vuexI18n from 'vuex-i18n'
// 项目启动时需要处理的东西
import Start from './start'
import RegionPicker from 'vue-region-picker'
import REGION_DATA from 'china-area-data'

Vue.use(RegionPicker, {
  region: REGION_DATA,
  vueVersion: 2
})

Start.run({ store })

Vue.use(ToastPlugin)
Vue.use(Vuex)

const stores = new Vuex.Store({
  modules: {
    i18n: vuexI18n.store
  }
})

Vue.use(vuexI18n.plugin, stores)
const translationsEn = {
  content: 'This is some {type} content'
}
Vue.i18n.add('en', translationsEn)

// set the start locale to use
Vue.i18n.set('en')
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
